export default __webpack_public_path__ + "static/media/delete-icon.b39e21e2.svg";